import React, { useEffect, useState } from 'react';
import { Table, Divider, Spin } from 'antd';
// import 'antd/dist/antd.css';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { AUTH_TOKEN } from '../../utils/authHeader';
import Navbar from '../../components/Navbar/Navbar';
import Sidebar from '../../components/Sidebar/Sidebar';

const List_GRN = () => {
  const [listData, setListData] = useState([]);
  const [loadSet, setLoadSet] = useState(false);
  const [creditNoteData, setCreditNoteData] = useState([]);

  const columns = [
    {
      title: 'Purchase Number',
      dataIndex: 'PO_Number',
      key: 'PO_Number',
    },
    {
      title: 'GRN Number',
      dataIndex: 'GRN_Number',
      key: 'GRN_Number',
    },
    {
      title: 'ASN Number',
      dataIndex: 'ASN_Number',
      key: 'ASN_Number',
    },
  ];

  useEffect(() => {
    axios
      .get(
        'https://vo1urbmb5k.execute-api.ap-south-1.amazonaws.com/dev/api/purchaseOrder/getAllPurchaseOrders',
        {
          headers: {
            Authorization: `Bearer ${AUTH_TOKEN()}`,
          },
        }
      )
      .then((res) => {
        console.log('GET:ALL-P-Order', res);
        setListData(res.data.data);
      })
      .catch((err) => {
        console.error('GET:ALL-P-Order', err);
      });
  }, []);

  useEffect(() => {
    if (listData.length > 0) {
      setLoadSet(true);
      const poNumbers = listData.map((po) => po.PO_Number);

      const promises = poNumbers.map((poNumber) =>
        axios.get(
          `https://6o22xu4u61.execute-api.ap-south-1.amazonaws.com/dev/api/grn/viewAllGRNList/${encodeURIComponent(poNumber)}`,
          {
            headers: {
              Authorization: `Bearer ${AUTH_TOKEN()}`,
            },
          }
        )
      );

      Promise.allSettled(promises)
        .then((results) => {
          const fulfilledResponses = results
            .filter((result) => result.status === 'fulfilled')
            .map((result) => result.value.data);

          const creditNoteData = fulfilledResponses.flat();

          console.log('GRN Data:', creditNoteData);
          setCreditNoteData(creditNoteData);
        })
        .catch((error) => {
          console.log('Error fetching GRN', error);
          setCreditNoteData([]);
        })
        .finally(() => {
          setLoadSet(false); // Set loading to false after requests complete
        });
    }
  }, [listData]);

  return (
    <>
      <main style={{ backgroundColor: '#80' }}>
        {loadSet && <div style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: "absolute",
          width: "100%",
          zIndex: 100,
          background: "#00000099"
        }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>}
        <div className="flex" style={{ backgroundColor: '#80' }}>
          <Sidebar />

          <section
            className="dashboard_wrapper"
            style={{ width: '80%', backgroundColor: '#80' }}
          >
            <Navbar title={'GRN / View All GRN List'} />

            <section
              className="lists_table"
              style={{
                background:
                  'white',
                boxShadow:
                  'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
                height: '80vh',
                width: '98%',
                margin: '1rem auto',
                padding: '1rem',
              }}
            >
              <h4 style={{ textAlign: 'center' }}> Goods Received Note </h4>
              <Divider />
              <Table dataSource={creditNoteData} columns={columns} />
            </section>
          </section>
        </div>
      </main>
    </>
  );
};

export default List_GRN;
